import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix Leaflet default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

const LocationMarker = ({ position, onLocationSelect }) => {
  useMapEvents({
    click(e) {
      onLocationSelect(e.latlng.lat, e.latlng.lng);
    },
  });

  return position ? <Marker position={position} /> : null;
};

const RecenterMap = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    if (center) {
      map.setView(center, map.getZoom());
    }
  }, [center, map]);
  return null;
};

const LocationPickerMap = ({ lat, lng, onLocationSelect, height = '300px' }) => {
  const [position, setPosition] = useState(
    lat && lng ? [lat, lng] : null
  );
  const defaultCenter = [48.0, 12.0]; // Central Europe default

  const handleSelect = (newLat, newLng) => {
    setPosition([newLat, newLng]);
    onLocationSelect(newLat, newLng);
  };

  useEffect(() => {
    if (lat && lng) {
      setPosition([lat, lng]);
    }
  }, [lat, lng]);

  return (
    <div className="rounded-md overflow-hidden border border-slate-200" style={{ height }} data-testid="location-picker-map">
      <MapContainer
        center={position || defaultCenter}
        zoom={position ? 10 : 5}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <LocationMarker position={position} onLocationSelect={handleSelect} />
        {position && <RecenterMap center={position} />}
      </MapContainer>
      <p className="text-xs text-slate-500 mt-1 px-1">
        Clicca sulla mappa per selezionare la tua zona
      </p>
    </div>
  );
};

export default LocationPickerMap;
